import { useEffect, useState } from 'react';
import { useTenant } from '@/modules/tenant/presentation/hooks/use-tenant';
import { tabsConfigContainer } from '../../di/container';
import {
  ALL_TABS_ON,
  editionTabsFrom,
  type EditionTabs,
} from '../../domain/entities/tabs.entity';

export type TabsConfigState =
  | { status: 'loading' }
  | { status: 'ready'; tabs: EditionTabs };

/**
 * As abas do painel para a prova e o ano deste build, do Remote Config
 * (`EXAMS_CAPTURE_TABS`). Com mocks, todas ligadas.
 *
 * Devolve `loading` em vez de já entregar um padrão, como no ENAMED: a barra
 * montaria com um conjunto de abas e trocaria por outro meio segundo depois. O
 * repositório guarda a busca, então o esqueleto só aparece na primeira carga.
 */
export function useTabsConfig(): TabsConfigState {
  const { id, edition } = useTenant();
  const repository = tabsConfigContainer.repository;
  const [state, setState] = useState<TabsConfigState>(() =>
    repository ? { status: 'loading' } : { status: 'ready', tabs: ALL_TABS_ON },
  );

  useEffect(() => {
    if (!repository) return;
    let isMounted = true;
    void repository.getConfig().then((config) => {
      if (isMounted) {
        setState({
          status: 'ready',
          tabs: editionTabsFrom(config, id, edition.year),
        });
      }
    });
    return () => {
      isMounted = false;
    };
  }, [repository, id, edition.year]);

  return state;
}
